const donations = [
  {
    id: "1",
    title: "Masjid Donation",
    authorTitle: "Masjid Donation",
    shortDes:
      "Donation for a masjid operational costs, rennovation, maintenance etc.",
    poster:
      "https://i.ibb.co/Nj02ddV/Whats-App-Image-2023-06-18-at-10-17-28.jpg",
  },

  // {
  //   id: "2",
  //   title: "Zakat Al Fitr",
  //   shortDes:
  //     "Zakat Al Fitr (also referred to as Fitra or Fitrana) has been set at $15 per person in New Zealand- be it man, woman or child.",
  //   poster: "https://i.ibb.co/CWZFnX3/zakat-al-fitr.jpg",
  //   rate: 15,
  // },

  {
    id: "3",
    title: "Zakat Al Maal",
    authorTitle: "Zakat Al Maal",
    shortDes:
      "Give Zakat al Maal to help the orphans, widows and families in need. Help us reach the Needy, Widows & Orphans with your Zakat.",
    poster:
      "https://i.ibb.co/z4BzJng/Whats-App-Image-2023-06-18-at-10-17-59.jpg",
  },

  {
    id: "9",
    title: "Dawah Donation",
    authorTitle: "Dawah Donation",
    shortDes: "Donate to our Dawah Program",
    poster:
      "https://i.ibb.co/6Rdm77y/Whats-App-Image-2023-06-18-at-10-15-26.jpg",
  },

  // {
  //   id: "5",
  //   title: "Our Masjid Iftar Program",
  //   shortDes: "",
  //   poster:
  //     "https://i.ibb.co/k1rs7n6/Whats-App-Image-2023-03-27-at-10-29-06.jpg",
  // },

  {
    id: "6",
    title: "Madrasha Donation",
    authorTitle: "Madrasha Donation",
    shortDes:
      "New Zealand Muslim Association is launching Madrasha program for kids aged 5-14 yrs. Please donate to facilitate the madrasha prgram.",
    poster:
      "https://i.ibb.co/wSkLZNh/Whats-App-Image-2023-06-18-at-10-16-29.jpg",
  },

   {
    id: "7",
    title: "Food Fund",
    authorTitle: "Janaza Van : Sadaqa e Jariya",
    shortDes: "",
    poster: "https://i.ibb.co.com/ksDpxmFt/sadaqa-e-jariya.jpg",
  },

  {
    id: "-1",
    title: "Touch Tap Go",
    authorTitle: "Touch Tap Go",
  },
];

export default donations;
